import React, { Suspense, lazy, useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import { DefaultLayout } from "../components/_layout";
import Loader from "../components/_default/Loader";
import siteData from "../_data";

const Title = "Faqs";
// Lazy load components
const FAQsSection = lazy(
  () => import("../components/_pages/FAQs/index") // Make sure this path matches your project structure
);

// Sections configuration
const sections = [{ id: "faqs", label: "FAQs", Component: FAQsSection }];

const FaqsPage = () => {
  const [visibleSections, setVisibleSections] = useState({});
  const sectionRefs = useRef({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
            observer.unobserve(entry.target); // Stop observing once it's visible
          }
        });
      },
      { threshold: 0.1 } // Adjust when the component is considered visible (10% here)
    );

    Object.keys(sectionRefs.current).forEach((id) => {
      if (sectionRefs.current[id]) {
        observer.observe(sectionRefs.current[id]);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <DefaultLayout
      title={`${Title} | ${siteData.brand.name}`}
      description="Frequently Asked Questions about Musa Institute for Academic and Skills Development"
      isFooterHome={false}
    >
      <>
        {/* Sections */}
        {sections.map(({ id, Component }) => (
          <Box
            key={id}
            id={id}
            ref={(el) => (sectionRefs.current[id] = el)}
            sx={{
              position: "relative",
              minHeight: "50vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {visibleSections[id] ? (
              <Suspense fallback={<Loader />}>
                <Component />
              </Suspense>
            ) : (
              <Loader />
            )}
          </Box>
        ))}
      </>
    </DefaultLayout>
  );
};

export default FaqsPage;
